import styled from "styled-components";

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
